// Route: /authentication/login-callback
const LoginCallbackPage = () => {
  return null;
};

export default LoginCallbackPage;
